const LAST_SYNCH_TS = 'lastMyCasaSynch';

export default LAST_SYNCH_TS;
